import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Loading from "./Loading";

export default function InviteClaim() {
  const { token } = useParams();
  const { claimInvite } = useAuth();
  const nav = useNavigate();
  const [error, setError] = useState("");
  const claimed = useRef(false);

  useEffect(() => {
    if (claimed.current) return;
    claimed.current = true;
    (async () => {
      const res = await claimInvite(token);
      if (!res.ok) {
        setError(res.error || "Invite invalid");
        return;
      }
      if (!res.user.profile_complete) {
        nav("/setup", { replace: true });
      } else {
        nav("/", { replace: true });
      }
    })();
  }, [token, claimInvite, nav]);

  if (error) {
    return (
      <div className="min-h-screen w-full bg-[#f8f9fa] flex flex-col items-center justify-center px-6 text-center">
        <div className="text-6xl mb-3">🚧</div>
        <h1 className="font-display font-black text-2xl">Invite unavailable</h1>
        <p className="text-[#6c757d] mt-2 max-w-sm">{error}</p>
        <button
          onClick={() => nav("/login", { replace: true })}
          className="mt-6 bg-[#1971c2] hover:bg-[#1864ab] text-white font-bold rounded-xl px-6 py-3 active:scale-95 transition-transform"
          data-testid="invite-error-back-login"
        >
          Go to login
        </button>
      </div>
    );
  }

  return <Loading label="Verifying your invite…" />;
}
